// Which routes actually need the account-wide shows/episodes datasets.
//
// The marketing site, legal pages and public show pages never read them, so the
// providers must not fetch hundreds of rows there (that work blocked the
// homepage's first interactions for large/admin accounts).

const PUBLIC_PREFIXES = [
  "/auth",
  "/login",
  "/signup",
  "/session-expired",
  "/terms",
  "/privacy",
  "/dmca",
  "/cookies",
  "/gdpr",
  "/help",
  "/blog",
  "/knowledgebase",
  "/docs",
  "/studios",
  "/studio-booking-action",
  "/careers",
  "/about",
  "/why-you-should-join-podgo",
  "/podcast/",
  "/s/",
  "/booking/",
  "/invite/",
  "/invitation/",
  "/contract-return",
  "/onboarding-demo",
];

/** True when the path is a portal/admin route that consumes shows or episodes. */
export function isPortalPath(pathname: string): boolean {
  if (pathname === "/") return false;
  return !PUBLIC_PREFIXES.some(
    (prefix) =>
      pathname === prefix ||
      pathname.startsWith(prefix.endsWith("/") ? prefix : `${prefix}/`),
  );
}
